import { Component, OnInit } from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";

@Component({
    selector: "app-syndicate-agreement",
    templateUrl: "./syndicate-agreement.component.html",
    styleUrls: ["./syndicate-agreement.component.scss"],
    standalone: true,
    imports: [IonicModule],
})
export class SyndicateAgreementComponent implements OnInit {
  userId: string;
  constructor(
    private matBottomSheet: MatBottomSheetRef<SyndicateAgreementComponent>,
    private analytics: AngularFireAnalytics,
    private authService: AuthService
  ) {}

  async ngOnInit() {
    await this.authService
      ?.getUid("SyndicateAgreementComponent")
      ?.then((uid) => {
        this.userId = uid;
        this.analytics.logEvent("syndicate_agreement_modal", { userId: this.userId });
      })
      .catch((error: any) => {
        return error;
      });
  }

  backToSyndicate() {
    this.matBottomSheet.dismiss();
  }
}
